import { render, staticRenderFns } from "./doctorReport.vue?vue&type=template&id=dbc99226&scoped=true&"
import script from "./doctorReport.vue?vue&type=script&lang=js&"
export * from "./doctorReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc99226",
  null
  
)

export default component.exports